import Swiper from 'swiper/bundle';

export default function initializeAllCollapsesFile() {
    document.querySelectorAll('.block-icon-boxes-slider').forEach(function(block) {
        new BlockIconBoxes(block);
    });
}

class BlockIconBoxes {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {

        if (innerWidth < 768) {
            const slider = this.block.querySelector('.block-icon-boxes__slider');


            const swiper = new Swiper(slider, {
                speed: 1000,
                spaceBetween: 24,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: document.querySelector('.block-icon-boxes__slider .slider__pagination--new'),
                    dynamicBullets: true,
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    0: {
                        slidesPerView: 1,
                    },
                },
            });
        } else {
            console.log (innerWidth);
            const slider = this.block.querySelector('.block-icon-boxes__slider:not(.block-icon-boxes__slider--disabled)');

            const swiper = new Swiper(slider, {
                speed: 1000,
                loop: true,
                spaceBetween: 24,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: this.block.querySelector('.block-icon-boxes-slider .slider__arrow--next'),
                    prevEl: this.block.querySelector('.block-icon-boxes-slider .slider__arrow--prev'),
                },
                pagination: {
                    el: document.querySelector('.block-icon-boxes__slider .slider__pagination--new'),
                    dynamicBullets: true,
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    0: {
                        slidesPerView: 1,
                    },
                },
            });
        }
    }
}
